import { makeStyles } from '@material-ui/core/styles';

const useEsTabbedContentStyles = makeStyles(
  () => ({
    root: {
      '& .swiper-dot-navigation': {
        display: 'flex !important',
      },
      '& .loader-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '150px',
      },
      '& .tabs-content': {
        minHeight: '150px',
      },
    },
  }),
  { name: 'EsTabbedContent' },
);

export default useEsTabbedContentStyles;

export const useEsTabbedPlaceholderContentStyles = makeStyles(
  () => ({
    placeholder: {
      display: 'block',
      '& .tabs-content': {
        display: 'grid',
        gap: '20px',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        '& .tabs-panel': {
          height: '400px',
          borderRadius: '4px',
          '& .tab-panel-image': {
            width: '100%',
            height: '150px',
          },
          '& .tab-panel-content': {
            padding: '20px',
            height: '250px',
            '& .tab-panel-title': {
              width: '70%',
              height: '20px',
              marginBottom: '20px',
            },
            '& .tab-panel-text-line': {
              height: '10px',
              marginBottom: '8px',
            },
          },
        },
      },
    },
  }),
  { name: 'useEsTabbedPlaceholderContent' },
);
